import React from 'react';
import PropTypes from 'prop-types';

const InputField = (props) => {
    const {
        type = '', placeholder = '', context = '', onChangeHandler,
        name = '', value = '', errorText = '', handleKeyDown, onBlur,
        inputClassName = '', autocomplete = "off"
    } = props;

    return (
        <div class="b2cform__group field">
            <input
                type={type}
                className={`b2cform__field ${inputClassName}`}
                placeholder={placeholder}
                name="name"
                id={name}
                value={value}
                onChange={(e) => onChangeHandler(e.target.value, context)}
                onKeyDown={(e) => handleKeyDown(e)}
                onBlur={(e) => onBlur(e, name)}
                autocomplete={autocomplete}
            />
            <label
                for={name}
                className="b2cform__label">
                {placeholder}
            </label>
            {errorText ?
                <span className="b2cform__label--error">
                    {errorText}
                </span> :
                ''
            }
        </div>
    )
}

InputField.propTypes = {
    type: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    context: PropTypes.string.isRequired,
    onChangeHandler: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func,
    onBlur: PropTypes.func
}

export default InputField;